import { AxiosRequestConfig, AxiosResponse } from 'axios';

import AbstractCRMApi from '../../AbstractCRMApi';
import LotteryTicket from '../../Models/LotteryTicket';
import GetLotteryTicketLineResponse from '../Responses/LotteryTicketLineResponse';
import GetLotteryTicketResponse from '../Responses/LotteryTicketResponse';
import GetPaginatedResponse from '../Responses/PaginatedResponse';

class TicketsApi extends AbstractCRMApi {
    public endpoint: string = 'lottery_ticket';

    public getById(ticketId: number): Promise<LotteryTicket> {
        return this.get(`/${ticketId}`).then((response: AxiosResponse) =>
            TicketsApi.mapDataToTicketClass(response.data)
        );
    }

    public getAll(
        page: number = 1,
        multidrawId?: number,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<LotteryTicket>> {
        return this.get('', {
            ...config,
            params: {
                ...config.params,
                page,
                multidrawId,
            },
        }).then((response: AxiosResponse<GetPaginatedResponse<GetLotteryTicketResponse>>) => {
            return AbstractCRMApi.mapPaginatedDataToModel(response.data, LotteryTicket);
        });
    }

    public getLines(
        ticketId: number,
        page: number = 1,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<GetLotteryTicketLineResponse>> {
        return this.get(`/${ticketId}/lines`, {
            ...config,
            params: { ...config?.params, page },
        }).then((response: AxiosResponse) => response.data);
    }
}

export default new TicketsApi();
